// Types
import { TableColumnItem } from './types';

/**
 * The function `formatColumns` takes an array of columns, filters out those with empty display names,
 * and formats the remaining columns with accessor keys and headers.
 */
export const formatColumns = (columns: TableColumnItem[]) => {
  if (!columns || !Array.isArray(columns)) {
    return [];
  }
  return columns.map(column => {
    const {
      key,
      displayName,
      align,
      pin,
      width,
      footer = '',
      ellipsis = true,
      toolTip = false,
    } = column;
    return {
      accessorKey: key,
      header: displayName || ' ',
      ellipsis,
      textAlign: align,
      pin,
      footer,
      toolTip,
      width: width ? width * 100 : undefined,
      cell: row => {
        const value = row?.[key];
        return typeof value === 'function' ? value() : value;
      },
    };
  });
};
